import { createModalEventManager } from "../../../shared/util/modalEvents";

type ViewjobResumeEvents = {
  resumeBuildCompleted: void;
};

export const { emit: emitViewjobResumeEvent, useEvent: useViewjobResumeEvent } =
  createModalEventManager<ViewjobResumeEvents>("ViewjobResume");
